import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AssetSearchComponent } from '@zero/shared/ui-web-components';
import { ModalComponent } from '@zero/shared/ui-web-design-system';
import { Asset } from '@zero/shared/util-models';
import { MultiOrderInstrument } from '@zero/trade/domain';

@Component({
  selector: 'trade-multi-order-instrument-search',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AssetSearchComponent, TranslocoPipe, ModalComponent],
  templateUrl: './multi-order-instrument-search.component.html',
})
export class MultiOrderInstrumentSearchComponent {
  @Input() public currentInstruments: MultiOrderInstrument[] = [];

  @Output() public assetPicked = new EventEmitter<Asset>();

  public readonly activeModal = inject(NgbActiveModal);
  public error = '';

  public pickAsset(asset: Asset): void {
    const buyInstruments = this.currentInstruments?.filter((instrument) => instrument.direction === 'buy');
    if (buyInstruments?.some((instrument) => instrument.isin === asset.isin)) {
      this.error = 'trade.multi-order.instrument-search.errors.duplicate';
      return;
    }

    this.assetPicked.emit(asset);
    this.activeModal.close();
  }
}
